<template>
    <Multiselect
        :options="options"
        v-model="internalValue"
        :placeholder="placeholder"
        :multiple="multiple"
        :hide-selected="true"
        :custom-label="customLabel"
        :searchable="false"
        :block-keys="['Delete']"
        track-by="key"
        :show-labels="false"
    >
        <template v-slot:tag="{ option }">
            <span class="tag mr-1 mb-1">
                {{ option.label }}
                <button class="delete" @click="removeOption(option)"></button>
            </span>
        </template>
        <template v-slot:noResult>
            {{ translate("common.no_results") }}
        </template>
    </Multiselect>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import translatorMixin from "./translatorMixin";

    /**
     * options prop accept array of objects: {key, label}
     */
    export default {
        name: "multiselect-input",
        components: { Multiselect },
        mixins: [translatorMixin],
        props: ["options", "modelValue", "placeholder", "multiple"],
        computed: {
            internalValue: {
                set(newValue) {
                    this.$emit("update:modelValue", newValue);
                },
                get() {
                    return this.modelValue;
                },
            },
        },
        methods: {
            customLabel(option) {
                return option.label;
            },
            removeOption(option) {
                this.internalValue = this.internalValue.filter(storedOption => storedOption.key !== option.key);
            },
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
